export default __webpack_public_path__ + "easydl-wenxin225450.png";